import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import Configs from "../Assets/editable-stuff/configurations.json";
import "../App";
import Seo from "../components/Seo";

const ComingSoonPage = () => {
  const icons = Configs.icons;

  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];
    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };

  const heroStyles = {
    container: {
      marginBottom: 0,
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      paddingTop: "80px"
    },
    content: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 20px"
    },
    heading: {
      fontSize: "clamp(2rem, 6vw, 3.5rem)",
      fontWeight: "700",
      letterSpacing: "-0.02em",
      lineHeight: "1.2",
      marginBottom: "24px",
      textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)"
    },
    buttonContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "16px",
      marginTop: "32px"
    },
    button: {
      padding: "14px 32px",
      fontSize: "1rem",
      fontWeight: "500",
      borderRadius: "12px",
      border: "2px solid rgba(255, 255, 255, 0.8)",
      background: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(10px)",
      transition: "all 0.3s ease"
    },
    socialContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
      marginTop: "40px",
      marginBottom: "40px"
    }
  };

  return (
    <div>
      <Seo
        title="Coming Soon | NeedForGeeks"
        description="This NeedForGeeks page is on the way. Check back soon."
        path="/comingsoon"
        noindex
      />
      <div
        id="comingsoon"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light"
        style={heroStyles.container}
      >
        <div style={heroStyles.content} className="container container-fluid text-center">
          <h1 style={heroStyles.heading}>Coming Soon</h1>
          <Typist
            className="lead"
            cursor={{ show: true, blink: true, element: '|', hideWhenDone: true }}
            avgTypingDelay={30}
          >
            <span>We're working on something exciting!</span>
            <Typist.Delay ms={500} />
            <span> Follow us on social media for updates.</span>
          </Typist>

          <div style={heroStyles.socialContainer}>
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "52px",
                  height: "52px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                  transition: "all 0.3s ease"
                }}
              >
                <i
                  className={`fab ${icon.image} fa-2x ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>

          <div style={heroStyles.buttonContainer}>
            <Link className="btn btn-outline-light" role="button" to="/" style={heroStyles.button}>
              Home
            </Link>
            <Link className="btn btn-outline-light" role="button" to="/it" style={heroStyles.button}>
              Information Technology
            </Link>
            <Link className="btn btn-outline-light" role="button" to="/web-app" style={heroStyles.button}>
              Websites & Apps
            </Link>
            <Link className="btn btn-outline-light" role="button" to="/automation" style={heroStyles.button}>
              Automation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;